import { useContext } from "react"
import { cn } from "@/lib/utils"
import { AlgoBuilderLogo } from "../AlgoBuilderLogo/AlgoBuilderLogo"
import { ThemeContext } from "../../providers/ThemeProvider.jsx"
import SMLogo from "../../assets/svg/sm-logo.svg?react"
import SMLogoWhite from "../../assets/svg/sm-logo_white.svg?react"

export interface SwitchMarketsBrandProps {
  /** Height of the AlgoBuilder logo, in px. */
  height?: number
  className?: string
}

/**
 * Co-branded lockup for the Switch Markets partnership pages: the AlgoBuilder
 * logo above "in partnership with <Switch Markets>".
 *
 * The Switch Markets mark is a flat two-tone SVG with no `currentColor`, so it
 * cannot follow the theme through tokens -- it ships as two files and the right
 * one is picked here. Used as the `brandSlot` of AuthLayout on the sponsored
 * sign-up and plan-change pages.
 */
export function SwitchMarketsBrand({ height = 22, className }: SwitchMarketsBrandProps) {
  const { theme } = useContext(ThemeContext) ?? {}
  const SwitchMarketsLogo = theme === "dark" ? SMLogoWhite : SMLogo

  return (
    <div className={cn("flex flex-col items-center gap-2", className)}>
      <a href="https://algobuilder.com">
        <AlgoBuilderLogo height={height} />
      </a>
      <p className="text-caption text-muted-foreground flex items-center gap-2">
        <span>in partnership with</span>
        <SwitchMarketsLogo />
      </p>
    </div>
  )
}
